/*
 *
 * DimensionByTeam constants
 *
 */

export const GET_DIVISIONS_WATCHER = "app/DimensionByTeam/GET_DIVISIONS_WATCHER"
export const GET_DIVISIONS_SUCCESS = "app/DimensionByTeam/GET_DIVISIONS_SUCCESS"
export const GET_DIVISIONS_FAILED = "app/DimensionByTeam/GET_DIVISIONS_FAILED"

export const GET_DIMENSIONS_WATCHER =
  "app/DimensionByTeam/GET_DIMENSIONS_WATCHER"
export const GET_DIMENSIONS_SUCCESS =
  "app/DimensionByTeam/GET_DIMENSIONS_SUCCESS"
export const GET_DIMENSIONS_FAILED = "app/DimensionByTeam/GET_DIMENSIONS_FAILED"

export const GET_QUESTIONS_WATCHER =
  "app/DimensionByTeam/GET_QUESTIONS_WATCHER"
export const GET_QUESTIONS_SUCCESS =
  "app/DimensionByTeam/GET_QUESTIONS_SUCCESS"
export const GET_QUESTIONS_FAILED =
  "app/DimensionByTeam/GET_QUESTIONS_FAILED"

export const GET_TEAMS_WATCHER = "app/DimensionByTeam/GET_TEAMS_WATCHER"
export const GET_TEAMS_SUCCESS = "app/DimensionByTeam/GET_TEAMS_SUCCESS"
export const GET_TEAMS_FAILED = "app/DimensionByTeam/GET_TEAMS_FAILED"

export const GRAPHIC_BARS_WATCHER = "app/DimensionByTeam/GRAPHIC_BARS_WATCHER"
export const GRAPHIC_BARS_SUCCESS = "app/DimensionByTeam/GRAPHIC_BARS_SUCCESS"
export const GRAPHIC_BARS_FAILED = "app/DimensionByTeam/GRAPHIC_BARS_FAILED"

export const GET_HISTORY_BY_TEAM_WATCHER =
  "app/DimensionByDivision/GET_HISTORY_BY_TEAM_WATCHER"
export const GET_HISTORY_BY_TEAM_SUCCESS =
  "app/DimensionByDivision/GET_HISTORY_BY_TEAM_SUCCESS"
export const GET_HISTORY_BY_TEAM_FAILED =
  "app/DimensionByDivision/GET_HISTORY_BY_TEAM_FAILED"

export const GET_MEASURE_COLOR_RANGE_WATCHER =
  "app/DimensionByDivision/GET_MEASURE_COLOR_RANGE_WATCHER"
export const GET_MEASURE_COLOR_RANGE_SUCCESS =
  "app/DimensionByDivision/GET_MEASURE_COLOR_RANGE_SUCCESS"
